import * as $ from 'jquery';
import * as React from 'react';
import Component from '../../Component';
import Age from '../../Components/Age';
import Back from '../../Components/Back';
import ETOL from '../../Components/ETOL';
import Line from '../../Components/Line';
import { fullNameFactory } from '../../Factories';
import { ETOLTABS, ORDER, STATUS, USERSTATUS, VIEWMODE } from '../../General';
import { Cookie, getURLParameter, handleJQXHRError, Jqxhrs } from '../../Utils';
import Download from './Download';
import Filters from './Filters';
import List from './List';

export default class Manager extends Component {
    protected jqxhrs = new Jqxhrs();
    private search: any;
    constructor(props?: any) {
        super(props);
        let viewMode = Cookie.read(Cookie.EMPLOYEES_AGE_VIEWMODE);
        if (!viewMode) {
            viewMode = VIEWMODE.LIST;
            Cookie.create(Cookie.EMPLOYEES_AGE_VIEWMODE, viewMode);
        }
        const t = this.translate();
        const sortByFields = [
            { name: t("name"), value: 'NAME' },
            { name: t("age"), value: 'AGE' },
            { name: t("birthdate"), value: 'BIRTHDATE' },
            { name: t("birthday"), value: 'BIRTHDAY' },];
        this.state = {
            filters: {
                search: { value: '' },
                employeeStatuses: { value: [USERSTATUS.ACTIVE, USERSTATUS.INVITED] },
                units: { value: [] },
                countries: { value: [] },
                offices: { value: [] },
                approvers: { value: [] },
                viewMode: viewMode,
                sortBy: this.getSortBy(sortByFields, 'ASC'),
            },
            employees: {
                arr: [],
                status: STATUS.LOADING
            },
        };
        this.search = Manager.search.bind(this);
    }

    public getSortBy(fields: any, defaultOrder: any) {
        const map = new Map();
        fields.forEach((field: any) => map.set(field.name, field.value))
        const sortBy = getURLParameter('sortBy');
        const order = getURLParameter('order')
        const field = map.get(sortBy) ? map.get(sortBy) : fields[1];
        return { field, order: order === 'ASC' ? 'ASC' : (order === 'DESC' ? 'DESC' : defaultOrder), fields };
    }

    componentDidMount() {
        this.search();
    }

    public static search(this: any, limit?: any) {
        const moment = this.getMomentWithLocale();
        const now = moment().startOf('day');
        const session = this.getSession().getState() as any;
        const t = this.translate();
        this.setState(
            { employees: { arr: [], status: STATUS.LOADING } },
            () => {
                this.jqxhrs.abortAndSet('search', $.ajax({
                    type: 'GET',
                    contentType: 'application/json',
                    url: this.Endpoints().getEmployeesAgeSearch({ filters: this.state.filters }),
                    dataType: 'json',
                    cache: false,
                    success: (data: any, textStatus: any, jqXHR: any) => {
                        if (data.list.length === 0) {
                            if (this.props.onEmpty) { this.props.onEmpty(); }
                        }
                        let list = data.list.map((row: any) => {
                            const ret = JSON.parse(row[1]);
                            ret.fullName = fullNameFactory(ret, session.company.nameFormat);
                            ret.birthDate = ret.birthDate ? moment(ret.birthDate).startOf('day') : null;
                            if (ret.birthDate) {
                                if (now.format('MM-DD') === ret.birthDate.format('MM-DD')) {
                                    ret.todayIsBirthDate = true;
                                }
                            }
                            ret.birthDay = ret.birthDate ? (moment(ret.birthDate).startOf('day').year(now.year()).isSameOrBefore(now) ?
                                moment(ret.birthDate).year(now.year() + 1)
                                : moment(ret.birthDate).year(now.year()))
                                : null;
                            ret.birthDayTimeStamp = ret.birthDay.valueOf()
                            ret.age = ret.birthDate ? Age.computeAge(ret.birthDate, now, ret.todayIsBirthDate) : 0;
                            ret.ageLiteral = ret.birthDate ? Age.computedAgeLiteral(ret.birthDate, now, t, ret.todayIsBirthDate) : '';
                            ret.next = ret.birthDay ? moment.duration(ret.birthDay.startOf('day').diff(now)) : null;
                            if (ret.todayIsBirthDate) {
                                ret.next = ret.birthDay ? moment.duration() : null;
                            }
                            return ret;
                        });
                        const sort = (a: any, b: any) => {
                            switch (this.state.filters.sortBy.field.value) {
                                case 'NAME':
                                    if (this.state.filters.sortBy.order === ORDER.ASC)
                                        return a.fullName.toLowerCase().localeCompare(b.fullName.toLowerCase(), 'en', { sensitivity: 'base' });
                                    else
                                        return b.fullName.toLowerCase().localeCompare(a.fullName.toLowerCase(), 'en', { sensitivity: 'base' });
                                case 'BIRTHDATE':
                                    if (this.state.filters.sortBy.order === 'ASC') {
                                        if (a.birthDayTimeStamp < b.birthDayTimeStamp)
                                            return -1;
                                        if (a.birthDayTimeStamp > b.birthDayTimeStamp)
                                            return 1;
                                        return 0;
                                    } else {
                                        if (a.birthDayTimeStamp > b.birthDayTimeStamp)
                                            return -1;
                                        if (a.birthDayTimeStamp < b.birthDayTimeStamp)
                                            return 1;
                                        return 0;
                                    }
                                case 'BIRTHDAY':
                                    if (this.state.filters.sortBy.order === 'ASC') {
                                        if (a.next < b.next)
                                            return -1;
                                        if (a.next > b.next)
                                            return 1;
                                        return 0;
                                    } else {
                                        if (a.next > b.next)
                                            return -1;
                                        if (a.next < b.next)
                                            return 1;
                                        return 0;
                                    }
                                case 'AGE':
                                    if (this.state.filters.sortBy.order === 'DESC') {
                                        if (a.birthDate < b.birthDate)
                                            return -1;
                                        if (a.birthDate > b.birthDate)
                                            return 1;
                                        return 0;
                                    } else {
                                        if (a.birthDate > b.birthDate)
                                            return -1;
                                        if (a.birthDate < b.birthDate)
                                            return 1;
                                        return 0;
                                    }
                            }
                        }
                        list.sort(sort);
                        if (limit)
                            list = list.slice(0, limit);
                        this.setState({ employees: { arr: list, status: STATUS.READY } });
                    },
                    error: (jqXHR: any, textStatus: any, errorThrown: any) => {
                        handleJQXHRError(jqXHR, textStatus, errorThrown, () => { this.setState({ data: { arr: null, count: 0, status: 'ERROR' } }); });
                    },
                    complete: (jqXHR: any, textStatus: any) => {
                        this.jqxhrs.complete('search');
                    }
                }));
            });
    }

    render() {
        const t = this.translate();
        return <div className="container-fluid">
            <div className="row"><div className="col-12 mb-3">
                <Back href={this.Urls().getEmployeesReports()} /> {t('age')}
            </div></div>
            <div className="row"><div className="col-12 mb-3"><Line /></div></div>
            <div className="row"><div className="col-12 mb-3"><ETOL currentTab={ETOLTABS.REPORTS} /></div></div>
            <div className="row"><div className="col-12 mb-3"><Line /></div></div>
            <Filters
                download={(new Download({ filters: this.state.filters }))}
                defaultFilters={this.state.filters} viewMode={this.state.filters.viewMode} sortBy={this.state.filters.sortBy}
                onChange={(value: any) => { this.setState({ filters: Object.assign({}, value) }, () => { this.search(); }); }}
            />
            <div className="row">
                <List employees={this.state.employees} viewMode={this.state.filters.viewMode} onRefresh={() => { this.search(); }} />
            </div>
        </div>
    }

    public componentWillUnmount() { this.jqxhrs.abortAll(); }
}